import React from 'react';
import { Input, Button, CheckboxTable, Select, Textarea } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket } from 'utils';
import { connect } from 'react-redux';
import { StarIcon, StarActiveIcon } from 'assets/icons';
import {
  SignatureService,
  RevisionService,
  CallService,
  PreparationService,
} from 'services';
import { TYPES } from './home';
import { WhiteImage } from 'assets/img';

interface Props extends RootState {
  onClose?: any;
  type?: any;
  item?: any;
}

class ModalRating extends React.Component<Props> {
  state = {
    form: {
      rating: 5,
    },
    item: this.props.item,
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  setStarActive = (rating: number) => {
    this.setState({
      form: {
        ...this.state.form,
        rating,
      },
    });
  };

  submit = async (e: any) => {
    if (e) {
      e.preventDefault();
    }

    const item: any = this.state.item;

    if (this.props.type == TYPES.REVISION) {
      await RevisionService.rating({
        revision_id: item?.id,
        user_id: this.props.user?.id,
        lawyer_id: item?.lawyer_id,
        rating: this.state.form.rating,
      });
    } else if (this.props.type == TYPES.SIGNATURE) {
      await SignatureService.rating({
        signature_id: item?.id,
        user_id: this.props.user?.id,
        lawyer_id: item?.lawyer_id,
        rating: this.state.form.rating,
      });
    } else if (this.props.type == TYPES.CALL) {
      await CallService.rating({
        call_id: item?.id,
        user_id: this.props.user?.id,
        lawyer_id: item?.lawyer_id,
        rating: this.state.form.rating,
      });
    } else if (this.props.type == TYPES.PREPARATION) {
      await PreparationService.rating({
        preparation_id: item?.id,
        user_id: this.props.user?.id,
        lawyer_id: item?.lawyer_id,
        rating: this.state.form.rating,
      });
    }

    this.props.onClose();
  };

  render() {
    const { rating } = this.state.form;
    const item: any = this.state.item;

    return (
      <form id="modal-rating" onSubmit={this.submit}>
        {item != null && (
          <div className="lawyer">
            <img
              src={
                item?.lawyer?.photo
                  ? Constants.BASE_STORAGE + item?.lawyer?.photo
                  : WhiteImage
              }
            />
            <div style={{ flex: 1 }}>
              <p className="bold">Abogado</p>
              <p className="name">{item?.lawyer?.full_name}</p>
            </div>
          </div>
        )}
        <p className="subtitle">Por favor califique al abogado</p>
        <div className="text-center">
          <div className="container-stars">
            <img
              src={rating >= 1 ? StarActiveIcon : StarIcon}
              onClick={() => this.setStarActive(1)}
            />
            <img
              src={rating >= 2 ? StarActiveIcon : StarIcon}
              onClick={() => this.setStarActive(2)}
            />
            <img
              src={rating >= 3 ? StarActiveIcon : StarIcon}
              onClick={() => this.setStarActive(3)}
            />
            <img
              src={rating >= 4 ? StarActiveIcon : StarIcon}
              onClick={() => this.setStarActive(4)}
            />
            <img
              src={rating >= 5 ? StarActiveIcon : StarIcon}
              onClick={() => this.setStarActive(5)}
            />
          </div>
          <div>
            <button type="submit" className="btn">
              Guardar
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ModalRating);
